import { FC, memo } from 'react';
import {
  HeroConversationMessage,
  ConversationMessageType,
} from '@vs-online-only-app/state';
import { MessageTypeComponentMap } from '../../model';

type Props = {
  message: HeroConversationMessage;
};

const SelectedConversationMessagesListItem: FC<Props> = ({ message }) => {
  const MessageComponent =
    MessageTypeComponentMap[message.attributes.type] ||
    MessageTypeComponentMap[ConversationMessageType.Text];

  return <MessageComponent message={message} />;
};

export default memo(SelectedConversationMessagesListItem);
